<template>
  <div>
    <List
      url="device-monitor/tasks/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
          <label>设备类型：</label>
          <el-select multiple v-model="selectDeviceTypes" @change="search" placeholder="选择设备类型(多选)" style="width:200px;margin-right:10px;" size="small">
            <el-option
              v-for="deviceType in DeviceTypeList"
              :label="deviceType.name"
              :key="deviceType.name"
              :value="deviceType.name"></el-option>
          </el-select>

          <label>设备型号：</label>
          <el-select multiple v-model="selectDeviceModels" @change="search" placeholder="选择设备型号(多选)" style="width:200px;margin-right:10px;" size="small">
            <el-option
              v-for="deviceModel in DeviceModelList"
              :label="deviceModel.name"
              :key="deviceModel.name"
              :value="deviceModel.name"></el-option>
          </el-select>

          <label>监控模板：</label>
          <el-select multiple v-model="selectTemplateTypes" @change="search" placeholder="选择监控模板(多选)" style="width:200px;margin-right:10px;" size="small">
            <el-option
              v-for="monitorTemplateType in MonitorTemplateTypeList"
              :label="monitorTemplateType.name"
              :key="monitorTemplateType.name"
              :value="monitorTemplateType.name"></el-option>
          </el-select>
        </el-col>

        <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
          <label>监控设备：</label>
          <el-select multiple v-model="selectTaskDevices" @change="search" placeholder="选择监控设备(多选)" style="width:200px;margin-right:10px;" size="small">
            <el-option
              v-for="device in TaskDeviceList"
              :label="device.device_name"
              :key="device.device_name"
              :value="device.device_name"></el-option>
          </el-select>

          <label>设备mac：</label>
          <el-input v-model="searchData.mac" size="small" style="width:200px;margin-right:10px;" placeholder="请输入设备MAC"></el-input>

          <el-button @click="search" type="primary" size="small" style="margin-right:10px;">Search</el-button>
          <el-button @click="add" type="primary" size="small" icon="el-icon-edit">新增设备监控任务</el-button>
        </el-col>
      </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <label>云平台：</label>
        <el-select multiple v-model="selectClouds" @change="search" placeholder="选择云平台(多选)" style="width:200px;margin-right:10px;" size="small">
          <el-option
            v-for="cloud in CloudEnvList"
            :label="cloud"
            :key="cloud"
            :value="cloud"></el-option>
        </el-select>

        <label>监控状态：</label>
        <el-select v-model="selectStatus" placeholder="选择监控状态" @change="search" style="width:125px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="status in switchStatus"
            :label="status"
            :key="status"
            :value="status"></el-option>
        </el-select>

        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
        <el-button @click="exportToCsv" type="primary" size="small" style="margin-right:10px;">导出数据</el-button>
      </div>

      <template v-slot:slot-switch="scope" >
         <el-switch v-model="scope.item.switchOriginValue" @change="changeSwicth($event,scope.item)"></el-switch>
      </template>
    </List>
    <DeviceMonitorTaskUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
      :clouds="CloudEnvList"
      :monitorTemplateTypeList="MonitorTemplateTypeList"
    ></DeviceMonitorTaskUpdateBox>
  </div>
</template>

<script>
import CsvExportor from 'csv-exportor';
import { SwitchStatus } from "../components/Index/data.js";
import List from "../components/common/List.vue";
import DeviceMonitorTaskUpdateBox from "../components/DeviceMonitor/DeviceMonitorTaskUpdateBox.vue";

export default {
  components: {
    List,
    DeviceMonitorTaskUpdateBox
  },
  data() {
    return {
      TaskDeviceList: [],
      selectTaskDevices: [],
      CloudEnvList: [],  // 从后端获取的 cloud 列表
      selectClouds: [],
      DeviceTypeList: [],
      selectDeviceTypes: [],
      DeviceModelList: [],
      selectDeviceModels: [],
      selectStatus: "全部",
      switchStatus: SwitchStatus,
      selectTemplateTypes: "",
      MonitorTemplateTypeList: [],
      title: "设备监控-监控任务",
      tanle: [
        { name: "device_name", label: "设备名称" },
        { name: "device_type", label: "设备类型" },
        { name: "device_model", label: "设备机型" },
        { name: "mac", label: "设备MAC" },
        { name: "cloud", label: "云平台" },
        { name: "template_name", label: "监控模板" },
        { name: "schedule", label: "定时周期" },
        { name: "switch", label: "监控是否启用" },
        // { name: "desc", label: "监控任务说明" },
        { name: "update_time", label: "修改时间" },
        { name: "operator", label: "操作人" }
      ],
      searchData: {
        device_name: "",
        device_type: "",
        device_model: "",
        mac: "",
        cloud: "",
        template_name: "",
        status: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
    this.fetchMonitorTasks();
    this.fetchDeviceTypes();
    this.fetchDeviceModels();
    this.fetchDeviceMonitorTemplateTypes();
  },
  methods: {
    exportToCsv() {
      // 获取要导出的数据
      const csvData = this.TaskDeviceList.map(item => {
        return {
          "设备名称": item.device_name,
          "设备类型": item.device_type,
          "设备机型": item.device_model,
          "设备MAC": item.mac,
          "云平台": item.cloud,
          "监控模板": item.template_name,
          "定时周期": item.schedule,
          "监控是否启用": item.status ? "开启" : "关闭",
          "修改时间": item.update_time,
          "操作人": item.operator
        };
      });

      // 定义 CSV 表头
      const heads = [
        "设备名称",
        "设备类型",
        "设备机型",
        "设备MAC",
        "云平台",
        "监控模板",
        "定时周期",
        "监控是否启用",
        "修改时间",
        "操作人"
      ];

      // 使用 CsvExportor 导出 CSV
      CsvExportor.downloadCsv(csvData, { header: heads }, '设备监控任务.csv');
    },
    dealList(data) {
      for (let i in data) {
        data[i].switchOriginValue = Boolean(data[i].status);
        data[i].switch = data[i].status ? "开启" : "关闭";
        data[i].update_time = this.changeDate(data[i].update_time);
      }
      return data;
    },
    changeSwicth(changeValue,itemData){
      var params = {
        id: itemData.id,
        device_name: itemData.device_name,
        template_name: itemData.template_name,
        schedule: itemData.schedule,
        desc: itemData.desc,
        status: +(changeValue)
      };
      var url = "device-monitor/tasks/" + itemData.id + "/";
      this.$http["patch"](
        url,
        params,
        () => {
          this.$baseNotice.message("状态更新成功");
          this.updateList++;
        }
      );
    },
    close() {
      this.updateBlock = false;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {
        schedule: '8 8 * * *',
        switch: '开启'
      };
      this.updateBlock = true;
    },
    edit(val) {
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
      this.updateForm.device_name = val.device_name.split(', ');
      this.updateBlock = true;
    },
    search() {
      this.searchData.device_name = this.selectTaskDevices.join(",");
      this.searchData.device_type = this.selectDeviceTypes.join(",");
      this.searchData.device_model = this.selectDeviceModels.join(",");
      this.searchData.template_name = this.selectTemplateTypes.join(",");
      this.searchData.cloud = this.selectClouds.join(",");
      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = +(this.selectStatus === '开启');
      };
      this.updateList++;
    },
    deletedata(val) {
      let url = "device-monitor/tasks/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.CloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    },
    fetchMonitorTasks() {
      this.$http["get"](
        "device-monitor/tasks/", {}, (data) => {
          this.TaskDeviceList = data.data.results;
        }
      );
    },
    fetchDeviceTypes() {
      this.$http["get"](
        "device-info/types/", {}, (data) => {
          this.DeviceTypeList = data.data.results;
        }
      );
    },
    fetchDeviceModels() {
      this.$http["get"](
        "device-info/models/", {}, (data) => {
          this.DeviceModelList = data.data.results;
        }
      );
    },
    fetchDeviceMonitorTemplateTypes() {
      this.$http["get"](
        "device-monitor/template-type/", {}, (data) => {
          this.MonitorTemplateTypeList = data.data.results;
          // this.MonitorTemplateTypeList.unshift("全部"); // 在数组开头插入 "全部" 元素
        }
      );
    },
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
